import * as React from 'react';

export const DefaultSearchDropdown = ({data, onOptionSelect}) => {
    if (data && data.length > 0) {
        return (
            <div className="search-options">
                {data.map(option => {
                    let parentText = '';
                    let parentParentText = '';
                    if (option.parent) {
                        parentText = `${option.parent.title} `;
                        if (option.parent.parent) {
                            parentParentText = `${option.parent.parent.title}`;
                        }
                    }
                    return (
                        <div
                            key={option.name}
                            className="option"
                            onClick={() => {
                                onOptionSelect(option);
                            }}
                        >
                            {parentParentText !== '' && <span> {parentParentText} </span>}
                            {parentText && <span> {parentText} </span>}
                            <span> {option.title} </span>
                        </div>
                    );
                })}
            </div>
        );
    } else {
        return null;
    }
};
